import { Injectable } from '@angular/core';
import { MapOverlayComponents } from '../../shared/enums/map-overlay-component.enum';

@Injectable({
    providedIn: 'root'
})

export class MapFullScreenLogicService {

    appendOverlaySelectorsToMap(overlaySelectors: string[]): void {
        const fullscreenElement = document.fullscreenElement;

        if (!fullscreenElement) {
            return;
        }

        overlaySelectors.forEach(selector => {
            const overlayElement = document.querySelector(selector) as HTMLElement;
            if (overlayElement) {
                fullscreenElement.appendChild(overlayElement);
            }
        });
    }

    onFullscreenChange = (): void => {
        const overlaySelectors = [
            `.${MapOverlayComponents.MapLayersControlForm}`,
            `.${MapOverlayComponents.MapFiltersForm}`,
            `.${MapOverlayComponents.MapSiteDataPreview}`,
            `.${MapOverlayComponents.MapLayerDetail}`,
            `.${MapOverlayComponents.MapLegend}`,
            `.${MapOverlayComponents.MapFieldPointModal}`
        ];
        this.appendOverlaySelectorsToMap(overlaySelectors);
    };

    moveDialogToFullscreenContainer(): void {
        const dialogSelectors = [
            `.${MapOverlayComponents.MapSiteDataPreview}`,
            `.${MapOverlayComponents.MapLayerDetail}`,
            `.${MapOverlayComponents.MapFieldPointModal}`
        ];

        this.appendOverlaySelectorsToMap(dialogSelectors);
    }

    validateFullScreen(): void {
        if (document.fullscreenElement) {
            document.exitFullscreen();
        }
    }
}
